// extracted by mini-css-extract-plugin
module.exports = {"SuggestionsWrapper":"Suggestions-module__SuggestionsWrapper","highlighted":"Suggestions-module__highlighted"};